import {
  descriptionUI,
  fileInputSchema,
  fileInputUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import { VA_FORM_IDS } from 'platform/forms/constants';
import environment from 'platform/utilities/environment';
import CheckUploadWarning from '../../../components/FormAlerts/CheckUploadWarning';
import SupportingDocumentDescription from '../../../components/FormDescriptions/SupportingDocumentDescription';
import { emptySchema } from '../../../definitions/sharedSchema';
import content from '../../../locales/en/content.json';
import {
  ALLOWED_FILE_TYPES,
  API_ENDPOINTS,
  MAX_FILE_SIZE_BYTES,
} from '../../../utils/constants';
import {
  createPayload,
  hideUploadWarningAlert,
  parseResponse,
} from '../../../utils/helpers';

const TITLE_TEXT = content['sign-as-rep-title--upload'];
const DESC_TEXT = content['sign-as-rep-document-description'];
const INPUT_LABEL = content['upload-doc-label'];

export default {
  uiSchema: {
    ...titleUI(TITLE_TEXT, DESC_TEXT),
    ...descriptionUI(SupportingDocumentDescription),
    'view:uploadSuccessAlert': {
      ...descriptionUI(CheckUploadWarning),
      'ui:options': { hideIf: hideUploadWarningAlert },
    },
    signAsRepresentativeDocumentUpload: fileInputUI({
      title: INPUT_LABEL,
      required: true,
      fileUploadUrl: environment.API_URL + API_ENDPOINTS.fileUpload,
      accept: ALLOWED_FILE_TYPES,
      formNumber: VA_FORM_IDS.FORM_10_10CG,
      maxFileSize: MAX_FILE_SIZE_BYTES,
      createPayload,
      parseResponse,
    }),
  },
  schema: {
    type: 'object',
    required: ['signAsRepresentativeDocumentUpload'],
    properties: {
      'view:uploadSuccessAlert': emptySchema,
      signAsRepresentativeDocumentUpload: fileInputSchema(),
    },
  },
};
